import { MAP_SERVICE_GET, MAP_SERVICE_LIST, SYSTEM_MAP_LIST, RESET, SYSTEM_MAP_GET } from '../actions/Events';

export default function (state = {}, action) {
  switch (action.type) {

    case SYSTEM_MAP_LIST:
      return { ...state, results: action.payload }

    case SYSTEM_MAP_GET:
      return { ...state, current: action.payload }

    case MAP_SERVICE_GET:
      return { ...state, currentMapService: action.payload }

    case MAP_SERVICE_LIST:
      return { ...state, resultsMapService: action.payload }

    case RESET:
      return {}

    default:
      return state
  }
}